var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnGamingSoftware(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99.488,
    height: 99.171,
    viewBox: "0 0 99.488 99.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "circle",
    x: 0,
    y: 0,
    width: 99.488,
    height: 99.171,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-gamingsoftware",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#circle)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "circle-2",
    "data-name": "circle",
    cx: 40.744,
    cy: 40.586,
    rx: 40.744,
    ry: 40.586,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "dots",
    transform: "translate(10.139 12.722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16132",
    "data-name": "Group 16132",
    transform: "translate(0 6.653)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1262",
    "data-name": "Ellipse 1262",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(13.539 51.341)",
    fill: "#e7e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1263",
    "data-name": "Ellipse 1263",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(4.832)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1264",
    "data-name": "Ellipse 1264",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(0 27.552)",
    fill: "#97d3f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16131",
    "data-name": "Group 16131",
    transform: "translate(38.922)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1265",
    "data-name": "Ellipse 1265",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(10.824 56.153)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1266",
    "data-name": "Ellipse 1266",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(19.398 24.535)",
    fill: "#97d3f1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1267",
    "data-name": "Ellipse 1267",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    fill: "#e7e6e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icn",
    transform: "translate(24.362 25.755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn-deceptors",
    transform: "translate(0 0)",
    opacity: 0.995
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M1164.829,1349.113h-3.786l-.748-3.028h-9.875l-.748,3.028h-3.786a1.328,1.328,0,1,0,0,2.656h18.944a1.328,1.328,0,1,0,0-2.656Z",
    transform: "translate(-1138.074 -1317.117)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12332",
    "data-name": "Path 12332",
    d: "M1449.807,73.772s7.631-.163,8.99,5.4-2.718,13.407-1.568,18.312l3.554-4.251V73.609S1449.7,73.772,1449.807,73.772Z",
    transform: "translate(-1429.334 -71.127)",
    fill: "#00aafc",
    opacity: 0.097
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12333",
    "data-name": "Path 12333",
    d: "M1430.662,88.593s6.691,15.5,20.9,15.732h-21.366Z",
    transform: "translate(-1429.826 -79.347)",
    fill: "#00aafc",
    opacity: 0.097
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M1109,1075h-28.429a3.084,3.084,0,0,0-3.075,3.075v21.28a3.061,3.061,0,0,0,3.061,3.06h28.429a3.084,3.084,0,0,0,3.075-3.075v-21.28A3.07,3.07,0,0,0,1109,1075Zm-.026,21.205a1.742,1.742,0,0,1-1.742,1.742h-7.967a1.474,1.474,0,0,0-1.4,1.022,1.024,1.024,0,0,1-.975.71h-4.217a1.024,1.024,0,0,1-.975-.71,1.475,1.475,0,0,0-1.4-1.022h-7.96a1.754,1.754,0,0,1-1.749-1.749v-16.523a1.742,1.742,0,0,1,1.742-1.742h24.9a1.754,1.754,0,0,1,1.749,1.749Z",
    transform: "translate(-1077.5 -1075)",
    fill: "#007dba"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icn_-_gaming_-_default",
    "data-name": "icn - gaming - default",
    transform: "translate(6.543 3.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12867",
    "data-name": "Path 12867",
    d: "M1488.331,1090.835c-.459,0-.865.03-1.263-.007a1.4,1.4,0,0,1-1.263-.835,5.793,5.793,0,0,1-.653-2.592.216.216,0,0,1,0-.046,11.583,11.583,0,0,1,.665-1.786,2.364,2.364,0,0,1,.945-.75c.205-.113.315-.18.331-.425a6.807,6.807,0,0,1,3.29-5.484c.2-.133.494-.2.376-.556-.016-.048.179-.206.3-.242a11.383,11.383,0,0,1,2.376-.644,22.507,22.507,0,0,1,5.687.141,10.4,10.4,0,0,1,1.435.439c.231.079.523.139.394.505-.017.05.114.172.2.226a6.989,6.989,0,0,1,3.487,5.678.451.451,0,0,0,.251.316,1.769,1.769,0,0,1,1.294,1.733.5.5,0,0,0,.056.267,1.562,1.562,0,0,1-.01,2.041c-.058.076-.041.208-.048.316a1.72,1.72,0,0,1-1.75,1.715.591.591,0,0,0-.6.45,6.342,6.342,0,0,1-5.593,4.1c-.127.013-.31,0-.367.077-.377.482-.912.4-1.428.4-.341,0-.684.013-1.024-.009a.84.84,0,0,1,.01-1.68c.568-.023,1.138-.015,1.707,0a.642.642,0,0,1,.442.152c.278.38.645.282,1.012.232a5.492,5.492,0,0,0,4.794-5.216q.014-2.375,0-4.751a5.876,5.876,0,0,0-5.8-5.618,33.38,33.38,0,0,0-4.184.1,5.725,5.725,0,0,0-5.067,5.529c-.011,1.879,0,3.757,0,5.636Z",
    transform: "translate(-1485.136 -1077.358)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12868",
    "data-name": "Path 12868",
    d: "M1539.2,1137.28a2.869,2.869,0,0,0-4.2-1.02,2.347,2.347,0,0,1-2.552-.005,2.819,2.819,0,0,0-4.038.8,7.622,7.622,0,0,0-1.143,6.115,1.177,1.177,0,0,0,2.049.679,15.489,15.489,0,0,0,1.568-1.459,1.3,1.3,0,0,1,1.021-.438c1.187.014,2.374.018,3.561,0a1.426,1.426,0,0,1,1.149.48,13.179,13.179,0,0,0,1.536,1.424,1.191,1.191,0,0,0,2.06-.736c.114-.529.137-1.075.2-1.614A7.984,7.984,0,0,0,1539.2,1137.28Zm-7.519,2.155h-.532v.508a.417.417,0,0,1-.833,0v-.508h-.532a.4.4,0,1,1,0-.8h.532v-.508a.417.417,0,0,1,.833,0v.508h.532a.4.4,0,1,1,0,.8Zm4.024,1.092a.542.542,0,1,1,.567-.542A.555.555,0,0,1,1535.706,1140.526Zm0-1.489a.542.542,0,1,1,.567-.542A.555.555,0,0,1,1535.706,1139.037Zm1.737,1.489a.542.542,0,1,1,.567-.542A.555.555,0,0,1,1537.443,1140.526Zm0-1.489a.542.542,0,1,1,.567-.542A.555.555,0,0,1,1537.443,1139.037Z",
    transform: "translate(-1522.97 -1130.301)",
    fill: "#007dba"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnGamingSoftware);
export default __webpack_public_path__ + "static/media/icn-gaming-software.a0e7f4b913740d2d0bb7732021271fcd.svg";
export { ForwardRef as ReactComponent };